import { createContext, useContext } from "react";

import type { articlePageLiveArticleBodyContent$data } from "scmp-app/queries/__generated__/articlePageLiveArticleBodyContent.graphql";

// Bot-only SSR bridge: holds the LiveArticle record fetched server-side for
// verified-bot requests (gated by @include(if: $includeLiveContents) on
// articlePageQuery). The record carries the ssrLiveContentsPreviewLiveArticle
// fragment spread, so it doubles as the fragment key consumed by
// SsrLiveContentsPreview. Humans get null and render live contents
// client-side.
export type BotOnlyLiveArticleContextValue = BotOnlyLiveArticleRecord | null;

type BotOnlyLiveArticleRecord = NonNullable<articlePageLiveArticleBodyContent$data["liveArticle"]>;

export const BotOnlyLiveArticleContext = createContext<BotOnlyLiveArticleContextValue>(null);

export const useBotOnlyLiveArticleContext = () => useContext(BotOnlyLiveArticleContext);
